import React, { useRef, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog'; 
import { useTranslation } from 'react-i18next';
import Loader from 'src/common/components/Loader.jsx';
// import { useParams } from 'react-router-dom';
import { 
    isIpad,
    isMobileView,
} from 'src/utils/util';
import { 
    ReportIssueContainer,  
 } from '../index.styled';
import {
    filesValidation,
    handleFileChange,
    handleDeleteFile,
    handleViewFile,
    handleClosePreview,
    handleSubmitReport
} from './handlers/ReportIssueFormHandler'; 
import PreviewImage from './PreviewImage';
import SuccessMessage from './SuccessMessage';
import ReportFormContent from './ReportFormContent';

const ReportIssueForm = (props) => {
    const { onClose, japaneseTranslations } = props;
    const { t } = useTranslation(); 
    // const { myCaseRef } = useParams();
    const [issueDescription, setIssueDescription] = useState('');
    const [attachedFiles, setAttachedFiles] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [fileValidationError, setFileValidationError] = useState('');
    const [showAttachLoader, setShowAttachLoader] = useState(false);
    const [emailCopy, setEmailCopy] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const fileInput = useRef();
    const isMobile = isMobileView(); 
    const isIpadDevice = isIpad();
    const isIphoneSE = isMobile && window.innerHeight < 700;

    // These are used by the handler functions
    const [docViewerUrl, setDocViewerUrl] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const userDetails = useSelector(
            (state) => state.loginReducer.hybrisUserDetails,
            shallowEqual
        );
    
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );

    const handleCancel = () => {
        if (onClose) {
            onClose();
        }
    }; 
    
    const onFileChange = (e) => {
        setFileValidationError('');
        const files = Array.from(e.target.files);
        if (files.length > 0 && filesValidation(files, t, setFileValidationError)) {
            handleFileChange(e, setAttachedFiles);
        }
    };

    const onDeleteFile = (index) => {
        handleDeleteFile(index, setAttachedFiles);
    };

    const onViewFile = (file) => {
        handleViewFile(file, setPreviewImage);
    };

    const onClosePreview = () => {
        handleClosePreview(setPreviewImage, setDocViewerUrl);
    }; 

    const onSubmit = async () => {
        await handleSubmitReport({
            issueDescription,
            attachedFiles,
            userDetails,
            emailCopy,
            // myCaseRef,
            setEmailCopy,
            setIsSubmitting,
            setShowSuccessMessage,
            setIssueDescription,
            setAttachedFiles
        });
    };

    return (
        <>
            <style>
                {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
            </style>
            <ModalDialog
                id="report-issue-modal"
                open={true}
                handleClose={onClose} 
                modalWidth = {!isMobile && '800px'}
                zIndex={isMobile ? 200001 : 20000}
                modalHeight={
                    isMobile 
                        ? 'auto' 
                        : showSuccessMessage 
                            ? (isIpadDevice ? '250px' : '226px')
                            : 'fit-content'
                }
                modalMaxHeight={'90vh'}
                modalMinHeight={(!isMobile && !showSuccessMessage)? '365px':''}
                overflowY={isMobile ? 'auto' : undefined}
                padding='0px'
            >
                <ReportIssueContainer
                    isIpad={isIpadDevice}
                    mbHeight={isIphoneSE?'550px': ''}
                    isMobile={isMobile}
                    isSuccess={showSuccessMessage}
                >
                {showSuccessMessage ? (
                    <SuccessMessage 
                        onClose={onClose} 
                        japaneseTranslations={japaneseTranslations}
                        isLanguageChanged={isLanguageChanged}
                    />
                ) : (
                    <ReportFormContent 
                        issueDescription={issueDescription}
                        setIssueDescription={setIssueDescription}
                        attachedFiles={attachedFiles}
                        onDeleteFile={onDeleteFile}
                        onViewFile={onViewFile}
                        fileInput={fileInput}
                        showAttachLoader={showAttachLoader}
                        fileValidationError={fileValidationError}
                        onFileChange={onFileChange}
                        emailCopy={emailCopy}
                        setEmailCopy={setEmailCopy}
                        handleCancel={handleCancel}
                        isSubmitting={isSubmitting}
                        onSubmit={onSubmit}
                        japaneseTranslations={japaneseTranslations}
                        isLanguageChanged={isLanguageChanged}
                    />
                )}
            </ReportIssueContainer>

            {/* File Preview Modal */}
            <PreviewImage 
                previewImage={previewImage}
                onClosePreview={onClosePreview}
            />
        </ModalDialog>
        </>
    );
};

export default ReportIssueForm;
